import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { VisionService } from '../services/vision.service';
import { SpinnerService } from '../services/spinner';
import { SurveyDetails } from '../models/dto/survey';
import { CriteriaDetails } from '../models/dto/criteria';
import { VisionModel } from '../models/vision.model';
import { Observable, Subscription } from 'rxjs';


@Component({
    selector: 'app-vision.criterias',
    templateUrl: './vision.criterias.component.html',
    styleUrls: ['./vision.criterias.component.scss']
})
export class VisionCriteriasComponent implements OnInit {
    returnData: any;
    currentSurvey: any;
    visionId: string;
    visionData: SurveyDetails;
    criterias1: Array<CriteriaDetails>;
    criterias2: Array<CriteriaDetails>;
    criterias3: Array<CriteriaDetails>;
    criterias4: Array<CriteriaDetails>;


    constructor(private visionService: VisionService, private router: Router, private visionModel: VisionModel,
        private spinnerService: SpinnerService) {
        this.currentSurvey = JSON.parse(localStorage.getItem('current_survey'));
    }

    ngOnInit() {
        if (!this.currentSurvey || this.currentSurvey === 'null') {
            const visionTypeId = this.visionModel.getCurrentSurveyTypeId();
            this.visionModel.setSurveyInStorageFromType(visionTypeId).subscribe(result => {
                this.currentSurvey = JSON.parse(localStorage.getItem('current_survey'));
            });
        }
        // delay and call data
        this.spinnerService.show();
        this.getData();
        this.spinnerService.hide();
    }

    getCriteriasOfType(importance: number) {
        const criterias = this.visionData.criterias.filter(x => x.importance === importance);
        if (criterias) {
            return criterias;
        }
        return [];
    }

    getData() {
        if (this.currentSurvey) {
            this.visionId = this.currentSurvey.id;
            this.visionService.getVisionData(this.visionId).subscribe(result => {
                this.visionData = result.Survey;
                this.criterias1 = this.getCriteriasOfType(1);
                this.criterias2 = this.getCriteriasOfType(2);
                this.criterias3 = this.getCriteriasOfType(3);
                this.criterias4 = this.getCriteriasOfType(4);
            });
        }
    }

    enregister() {
        this.router.navigateByUrl('home/user');
    }

}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/vision/vision.criterias.component.ts